var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFitnessHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1151 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745117 22.6384 0.745117 50.2484C0.745117 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74512 74.5084 6.74512 50.2484C6.74512 42.7784 8.61512 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7951 67.3384C60.4251 68.0184 59.6651 68.4084 58.9051 68.2884C58.1351 68.1684 57.5251 67.5884 57.3751 66.8184L54.0351 49.5484L50.0651 76.3984C49.9351 77.2684 49.2151 77.9184 48.3351 77.9584C48.3051 77.9584 48.2751 77.9584 48.2451 77.9584C47.4051 77.9584 46.6651 77.3784 46.4651 76.5584L41.6251 56.7884L40.1551 61.6884C39.9251 62.4684 39.2051 62.9984 38.3951 62.9984H22.9551C28.2351 71.5584 37.0851 79.6184 50.7451 86.9884H50.7651C66.3951 78.5484 75.7251 69.2084 80.6251 59.2484H65.1351L60.8151 67.3284L60.7951 67.3384Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4451 22.1484C59.8151 22.1484 53.9951 25.6484 50.7451 30.9084C47.4951 25.6484 41.6851 22.1484 35.0451 22.1484C24.8651 22.1484 16.6051 30.3984 16.6051 40.5884H16.4151C16.5651 47.0284 17.9251 53.2884 20.9151 59.3284H37.0351L40.0451 49.2684C40.2751 48.4884 40.9951 47.9584 41.8051 47.9584H41.8551C42.6851 47.9784 43.3951 48.5484 43.5951 49.3584L47.8151 66.5884L51.9951 38.3684C52.1251 37.4884 52.8751 36.8184 53.7751 36.7984C54.6751 36.7684 55.4451 37.4084 55.6151 38.2884L60.0151 61.0584L62.4151 56.5684C62.7351 55.9684 63.3551 55.5984 64.0351 55.5984H82.2351C84.0951 50.7284 84.9751 45.7184 85.0951 40.5984H84.9051C84.9051 30.4184 76.6551 22.1584 66.4651 22.1584L66.4451 22.1484Z",
    fill: "#FF4D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1700",
    x: -0.0000186563,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1700",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1700"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1700",
    result: "effect3_innerShadow_4857_1700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessHealth);
export default __webpack_public_path__ + "static/media/FitnessHealth.f652df7b3328a9800e6a6afa0f6396f6.svg";
export { ForwardRef as ReactComponent };